import { FirebaseReducer } from '@/core/features/firebase/redux/Slice';
import { UserReducer } from '@/core/features/users/redux/Slice';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { GlobalDataReducer } from '../features/global-data/redux/Slice';
import { productCategoryReducer } from '@/core/features/product-category/redux/slice';

const reducer = combineReducers({
    firebase: FirebaseReducer,
    user: UserReducer,
    globalData: GlobalDataReducer,
    productCategory: productCategoryReducer,
});

export const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type RootState = ReturnType<typeof reducer>;
